import { Asset, useRouter, useRouterState, useTags } from "@tanstack/react-router";

import { localizeProps, setRenderLang } from "@/lib/pt-localize";

/** Same tags as HeadContent, with titles and descriptions in the address's language. */
export function LocalizedHeadContent() {
  const router = useRouter();
  const lang = useRouterState({
    select: (s) => (s.matches[0]?.context as { getLang?: () => string } | undefined)?.getLang?.() ?? "en",
  });
  // The head renders before the language provider; use this request's language.
  setRenderLang(lang);
  const tags = useTags();
  const nonce = router.options.ssr?.nonce;
  return (
    <>
      {tags.map((tag) => (
        <Asset key={`tsr-meta-${JSON.stringify(tag)}`} {...localizeProps(tag)} nonce={nonce} />
      ))}
    </>
  );
}
